<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section id="pdfDom" :class="loadingPdf ? 'pdf-width' : ''" class="app-content position-relative">
            <div id="entity-viewer" v-menu-permission="'list'" class="content">
                <div class="card">
                    <div id="collapseOne" aria-labelledby="headingOne" class="collapse show"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :business-data="$_emWorkflowTaskMixin_businessData"
                                                              :entity="modelName">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <WorkflowProcessLine ref="processExecution"
                                 :businessKey="$_emWorkflowTaskMixin_businessKey"
                                 :config="config"
                                 :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                                 @gotItems="setLocalVariables">
            </WorkflowProcessLine>
            <div v-if="$_emWorkflowTaskMixin_isShowTaskComplete" id="em-workflow-task-complete" class="content">
                <WorkflowTaskComplete :businessKey="$_emWorkflowTaskMixin_businessKey"
                                      :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                                      :config="config"
                                      :status="$_emWorkflowTaskMixin_businessData.status"
                                      :task-id="$_emWorkflowTaskMixin_taskId"
                                      syncValueChange>
                </WorkflowTaskComplete>
            </div>
            <em-button v-if="!loadingPdf" class="btn btn-outline-primary btn-sm position-absolute top right mt-1 mr-1"
                       style="z-index: 900"
                       type="downloadFile"
                       @click="savePdf">
            </em-button>
        </section>
    </div>
</template>
<script>
// Author Lin
// Date 2021-08-16 17:52:43

import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete";
import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine";
import inventoryTransportApplicationProcessMixin
    from "@/views/sithMes/inventory/inventoryTransportApplicationProcessMixin";

export default {
    name: "sithMesInventoryTransportApplicationWorkflowTaskView",
    components: {WorkflowProcessLine, WorkflowTaskComplete},
    mixins: [emWorkflowTaskMixin, inventoryTransportApplicationProcessMixin],
    data() {
        return {
            htmlTitle: '导出PDF',
            loadingPdf: false
        }
    },
    methods: {
        savePdf() {
            this.loadingPdf = true;
            setTimeout(() => this.getPdf('#pdfDom'), 2000);
            setTimeout(() => this.loadingPdf = false, 5000);
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        $_emWorkflowTaskMixin_callbackApi() {
            return process.env.VUE_APP_SITHMES_INVENTORY_URL + "/sithMesInventoryTransportApplication/complete-feedback";
        },
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit('workflow/setTaskListNeedRefresh', true);
        next();
    },
};
</script>
<style scoped>
.pdf-width {
    width: 900px;
}
</style>
<style scoped>
.pdf-width {
    width: 900px;
}
</style>
<style scoped>
.pdf-width {
    width: 900px;
}
</style>

<style scoped>
::v-deep .card-body .row div:nth-child(14) .control-label {
    width: 200px;
}
</style>
